window.toggle = function (clickedElement) {
    const label = document.querySelector(`label[for="${clickedElement.id}"]`);
    if (label) {
        if (clickedElement.checked) {
            label.textContent = 'On';
        } else {
            label.textContent = 'Off';
        }
    }
};

// Function to toggle the canary bar visibility using a class
window.toggleCanaryBar = function () {
    const canaryBar = document.querySelector('.mcp-canary-bar');
    if (canaryBar) {
        canaryBar.classList.toggle('hidden');
    }
};
